"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactDom = require("react-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
const createContainer = (containerId, parentNode, className) => {
  if (!(0, _ark.isString)(containerId) || containerId.length <= 0) return null;
  let container = document.getElementById(containerId);
  if (container !== null) return container;
  container = document.createElement('div');
  container.setAttribute('id', containerId);
  container.setAttribute('style', 'position: absolute; top: 0; left: 0; bottom: 0; right: 0');
  container.setAttribute('class', (0, _ark.conditionalConcat)('dom-container', className));
  parentNode.appendChild(container);
  return container;
};
const destroyContainer = containerId => {
  const container = document.getElementById(containerId);
  if (container === null || container.childElementCount > 1) return;
  container.remove();
};
const DomContainer = _ref => {
  let {
    className,
    children,
    node = document.body,
    containerId = 'dom-container'
  } = _ref;
  (0, _react.useEffect)(() => () => {
    destroyContainer(containerId);
  }, [containerId]);
  node = node ?? document.body;
  const containerNode = createContainer(containerId, node, className);
  if (containerNode === null) return null;
  return /*#__PURE__*/(0, _reactDom.createPortal)(children, containerNode);
};
DomContainer.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  node: _propTypes.default.instanceOf(HTMLElement),
  containerId: _propTypes.default.string
};
DomContainer.defaultProps = {
  className: undefined,
  children: undefined,
  node: undefined,
  containerId: 'dom-container'
};
var _default = exports.default = DomContainer;